import type { EmptyT, RatingT } from '@mentimeter/question-modules-types';

const isEmptyArray = (response: any) =>
  Array.isArray(response) && response.length === 0;

const isArrayWithTwoNumbers = (response: any) =>
  Array.isArray(response) &&
  response.length === 2 &&
  response[0] !== null &&
  response[1] !== null;

export const transformResults = ({
  results,
}: {
  results: RatingT | EmptyT;
}) => {
  const filteredResults = results.results.filter((result) =>
    isArrayWithTwoNumbers(result.score),
  ) as Array<{ id: number; score: [number, number] }>;

  return filteredResults.map((result) => {
    const responses =
      results.type === 'rating' ? (results.votes[result.id] ?? []) : [];

    const filteredResponses = responses.filter(
      (response): response is [number, number] =>
        isEmptyArray(response) || isArrayWithTwoNumbers(response),
    );
    return {
      id: result.id,
      score: {
        total: result.score,
        responses: filteredResponses,
      },
    };
  });
};
